import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AuthOtp, AuthOtpReq } from '../auth-otp.model';

export enum AuthOtpActionTypes {
  LoadAuthOtps = '[AuthOtp] Load AuthOtps',
  AddAuthOtp = '[AuthOtp] Add AuthOtp',
  UpsertAuthOtp = '[AuthOtp] Upsert AuthOtp',
  AddAuthOtpFail = '[AuthOtp] Add AuthOtp Fail',
  AddAuthOtpSuccess = '[AuthOtp] Add AuthOtp Success',
  CheckAuthOtp = '[AuthOtp] Check AuthOtp',
  CheckAuthOtpFail = '[AuthOtp] Check AuthOtp Fail',
  CheckAuthOtpSuccess = '[AuthOtp] Check AuthOtp Success',
  EnableAuthOtp = '[AuthOtp] Enable AuthOtp',
  EnableAuthOtpFail = '[AuthOtp] Enable AuthOtp Fail',
  EnableAuthOtpSuccess = '[AuthOtp] Enable AuthOtp Success',
}

export class LoadAuthOtps implements Action {
  readonly type = AuthOtpActionTypes.LoadAuthOtps;

  constructor(public payload: { authOtps: AuthOtp[] }) {}
}

export class AddAuthOtp implements Action {
  readonly type = AuthOtpActionTypes.AddAuthOtp;

  constructor(public payload: AuthOtp) {}
}

export class UpsertAuthOtp implements Action {
  readonly type = AuthOtpActionTypes.UpsertAuthOtp;

  constructor(public payload: { authOtps: AuthOtp }) {}
}

export class AddAuthOtpFail implements Action {
  readonly type = AuthOtpActionTypes.AddAuthOtpFail;
  constructor(public payload: AuthOtpReq) {
  }
}

export class AddAuthOtpSuccess implements Action {
  readonly type = AuthOtpActionTypes.AddAuthOtpSuccess;

  constructor(public payload: AuthOtpReq) {
  }
}

export class CheckAuthOtp implements Action {
  readonly type = AuthOtpActionTypes.CheckAuthOtp;

  constructor(public payload: any = null)  {
  }
}

export class CheckAuthOtpFail implements Action {
  readonly type = AuthOtpActionTypes.CheckAuthOtpFail;
  constructor(public payload: AuthOtpReq) {
  }
}

export class CheckAuthOtpSuccess implements Action {
  readonly type = AuthOtpActionTypes.CheckAuthOtpSuccess;

  constructor(public payload: AuthOtpReq) {
  }
}


export class EnableAuthOtp implements Action {
  readonly type = AuthOtpActionTypes.EnableAuthOtp;

  constructor(public payload: any = null)  {
  }
}

export class EnableAuthOtpFail implements Action {
  readonly type = AuthOtpActionTypes.EnableAuthOtpFail;
}

export class EnableAuthOtpSuccess implements Action {
  readonly type = AuthOtpActionTypes.EnableAuthOtpSuccess;

  constructor(public payload: AuthOtpReq) {
  }
}

export type AuthOtpActions =
 LoadAuthOtps
 | AddAuthOtp
 | UpsertAuthOtp
 | AddAuthOtpFail
 | AddAuthOtpSuccess
 | CheckAuthOtp
 | CheckAuthOtpFail
 | CheckAuthOtpSuccess
 | EnableAuthOtp
 | EnableAuthOtpFail
 | EnableAuthOtpSuccess;
